import { faClipboardList, faList, faNewspaper, faSignOutAlt, faTimes, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { Accordion } from 'react-bootstrap'
import { Link, useRouteMatch } from 'react-router-dom'
import { getUserCourseAPI, getUserInfoAPI } from '../../Api/ClientServices'
import Style from './UserPanelSideControl.module.css'
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom'
import { errorToast } from '../../Utils/Toast/Toast'


const UserPanelSideControl = ({show,setShow}) => {
    const history=useHistory()
    let { url } = useRouteMatch();
    const[info,setInfo]=useState()
    const[course,setCourse]=useState()
    useEffect(()=>{
        getUserInfo()
    },[])
    const getUserInfo=async()=>{
        const data=await getUserInfoAPI()
        const data2=await getUserCourseAPI()
        setInfo(data.info)
        setCourse(data2.course)
    }
    let loadingHandler=null

    const sendToCommentPage=(id)=>{
        setTimeout(()=>history.push(`/panel/comment/${id}`),100)
    }

    if(course===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
      </div>
    }
    else{
        loadingHandler=course.map(item=>{
            return(
                <Accordion.Body key={item.id} className={Style.Accaredon} onClick={()=>sendToCommentPage(item.id)}>
                    {
                        item.name
                    }
                </Accordion.Body>
            )
        })
    }
    const signOutHandler=()=>{
        errorToast("با موفقیت خارج شدید")
        localStorage.clear()
        setTimeout(()=>window.location.reload(),2000)
    }
    return (
        <div className={Style.SideHolder}
        style={{
            transform:` translateX(${show?'0':'-300vh'})`
        }}
        >
            <FontAwesomeIcon icon={faTimes} className={Style.CloseBtn} onClick={()=>setShow(false)}/>
            <section className={Style.UserPanelSideBar}>
                <FontAwesomeIcon icon={faUser} className={Style.UserIcon}/>
                <h3> {info===undefined?'منتظرباشید':`${info.first_name} ${info.last_name}`}</h3>
                <Link to={`${url}`}><FontAwesomeIcon icon={faNewspaper}/> لایسنس شما</Link>
                <Accordion defaultActiveKey="0" flush className={Style.AcaredonHolder}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header className={Style.AccordionHeader}><FontAwesomeIcon icon={faList}/>  دوره ها </Accordion.Header>
                        {
                            loadingHandler
                        }
                    </Accordion.Item>
                </Accordion>
                <Link to={`${url}/allcourse`}> <FontAwesomeIcon icon={faClipboardList}/> همه دوره ها</Link>
                <Link to={`/`}> <FontAwesomeIcon icon={faClipboardList}/> بازگشت به خانه</Link>
                <p className={Style.signOut} onClick={signOutHandler}>  <FontAwesomeIcon icon={faSignOutAlt}/> خروج </p>
            </section>
        </div>
    )
}

export default UserPanelSideControl
